import {
  NOTIFICATION_GET_REQUEST,
  NOTIFICATION_GET_REQUEST_FAILED,
  NOTIFICATION_GET_REQUEST_SUCCESS,
  NOTIFICATION_MARK_READED,
  NOTIFICATION_MARK_READED_FAILED,
  NOTIFICATION_MARK_READED_SUCCESS
} from "../constants";

export const getNotifications = () => {
  return { type: NOTIFICATION_GET_REQUEST };
};
export const getNotificationsFailed = payload => {
  return { type: NOTIFICATION_GET_REQUEST_FAILED, payload };
};
export const getNotificationsSuccess = payload => {
  return { type: NOTIFICATION_GET_REQUEST_SUCCESS, payload };
};

export const setNotificationViewed = payload => {
  return { type: NOTIFICATION_MARK_READED, payload };
};
export const setNotificationViewedFailed = () => {
  return { type: NOTIFICATION_MARK_READED_FAILED };
};
export const setNotificationViewedSuccess = payload => {
  return { type: NOTIFICATION_MARK_READED_SUCCESS, payload };
};
